import { SharedModule } from 'src/app/shared/shared.module'

import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { StoreModule } from '@ngrx/store'
import * as fromSupervisorBooking from './supervisor-booking.reducer'
import { EffectsModule } from '@ngrx/effects'
import { TagModule } from '../../tag/tag.module'
import { SupervisorBookingEffects } from './supervisor-booking.effects'
import { SupervisorBookingService } from './supervisor-booking.service'
import { SupervisorBookingSerializer } from './supervisor-booking.serializer'
import { SupervisorBookingIndex } from './index/index.component'
import { SupervisorBookingDetailsModalComponent } from './details-modal/show.component'
import { BookingModule } from '../../booking/booking.module'

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        TagModule,
        BookingModule,
        StoreModule.forFeature(fromSupervisorBooking.FEATURE_NAME, fromSupervisorBooking.supervisorBookingReducer),
        EffectsModule.forFeature([SupervisorBookingEffects])
    ],
    declarations: [
        SupervisorBookingIndex,
        SupervisorBookingDetailsModalComponent
    ],
    exports: [],
    providers: [
        SupervisorBookingService,
        {
            provide: SupervisorBookingSerializer,
            useClass: SupervisorBookingSerializer
        }
    ]
})
export class SupervisorBookingModule {}
